(() => {
  'use strict';
  // Language-based display only. Shopify still calculates destination checkout prices.
  // BEGIN LOCALIZED MONEY FORMATTER
  const localizedMoney = (cents, source, target, locale, rates) => {
    if (!Number.isFinite(cents) || cents < 0 || !/^[A-Z]{3}$/.test(source) || !/^[A-Z]{3}$/.test(target)) return null;
    let amount = cents / 100;
    const estimate = source !== target;
    if (estimate) {
      if (!Number.isFinite(rates?.[source]) || rates[source] <= 0 || !Number.isFinite(rates?.[target]) || rates[target] <= 0) return null;
      amount = amount * rates[source] / rates[target];
    }
    if (!Number.isFinite(amount)) return null;
    const formatted = new Intl.NumberFormat(locale, {
      style: 'currency', currency: target, currencyDisplay: target === 'USD' ? 'code' : 'symbol',
      minimumFractionDigits: target === 'USD' ? 2 : 0, maximumFractionDigits: target === 'USD' ? 2 : 0
    }).format(amount);
    return { text: (estimate ? '≈ ' : '') + formatted, estimate };
  };
  // END LOCALIZED MONEY FORMATTER
  const refreshLocalizedPrices = () => {
    const language = document.documentElement.lang.split('-')[0];
    const target = { vi: 'VND', ja: 'JPY', en: 'USD' }[language];
    if (!target) return;
    const locale = { vi: 'vi-VN', ja: 'ja-JP', en: 'en-US' }[language];
    const converted = new Set();
    document.querySelectorAll('[data-money-cents]').forEach(node => {
      const source = node.dataset.moneyCurrency;
      if (node.dataset.moneyCents === '') return;
      if (!node.dataset.originalMoney) node.dataset.originalMoney = node.textContent;
      const result = localizedMoney(Number(node.dataset.moneyCents), source, target, locale, window.Currency?.rates);
      if (!result) {
        node.textContent = node.dataset.originalMoney;
        node.removeAttribute('title');
        return;
      }
      node.textContent = result.text;
      if (result.estimate) {
        node.title = node.dataset.originalMoney;
        converted.add(node);
      } else node.removeAttribute('title');
    });
    const note = {
      vi: 'Giá có dấu ≈ là giá quy đổi tham khảo. Đơn vị tiền tệ và tổng tiền cuối cùng được xác nhận theo địa chỉ giao hàng khi thanh toán.',
      ja: '≈ の価格は参考換算額です。最終的な通貨と合計金額は、お届け先に応じて購入手続きで確定します。',
      en: 'Prices marked ≈ are converted estimates. Final currency and total are confirmed at checkout for your delivery address.'
    }[language];
    document.querySelectorAll('.product-grid, .product-feature__info, .cart-summary').forEach(container => {
      const needsNote = [...container.querySelectorAll('[data-money-cents]')].some(node => converted.has(node));
      let disclosure = container.querySelector('[data-currency-disclosure]');
      if (!disclosure && needsNote) {
        disclosure = document.createElement('p');
        disclosure.className = 'price-context';
        disclosure.dataset.currencyDisclosure = '';
        disclosure.style.gridColumn = '1 / -1';
        const price = container.querySelector('.product-price, .cart-total');
        if (price) price.after(disclosure); else container.prepend(disclosure);
      }
      if (disclosure) { disclosure.textContent = note; disclosure.hidden = !needsNote; }
    });
  };
  const initialized = new WeakSet();
  const messages = JSON.parse(document.querySelector('[data-theme-messages]')?.textContent || '{}');
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-language-select]')) return;
    const form = event.target.form;
    const returnTo = form.querySelector('[name=return_to]');
    if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
    form.requestSubmit();
  });
  const initializedForms = new WeakSet();
  const root = window.Shopify?.routes?.root || '/';
  document.addEventListener('click', event => {
    const menu = document.querySelector('#MobileNav');
    if (event.target.closest('[data-open-menu]')) menu?.showModal();
    if (event.target.closest('[data-close-menu]') || (event.target.closest('#MobileNav a') && menu?.open)) menu?.close();
  });
  const menu = document.querySelector('#MobileNav');
  menu?.addEventListener('click',event=>{if(event.target===menu && event.clientX<menu.getBoundingClientRect().left) menu.close();});
  menu?.addEventListener('close',()=>document.querySelector('[data-open-menu]')?.focus());
  const updateCount = async () => {
    try {
      const response = await fetch(`${root}cart.js`,{headers:{Accept:'application/json'}});
      if(!response.ok)return;
      const cart=await response.json();
      document.querySelectorAll('[data-cart-count]').forEach(node=>node.textContent=cart.item_count);
      document.querySelectorAll('.cart-link').forEach(node=>node.setAttribute('aria-label',messages.cart_count.replace('__COUNT__', cart.item_count)));
    } catch {}
  };
  const toast = () => {
    const node=document.querySelector('[data-toast]');
    node.replaceChildren(document.createTextNode(messages.added));
    const link=document.createElement('a');link.href=`${root}cart`;link.textContent=messages.view_cart;node.append(link);
    node.hidden=false;clearTimeout(node.timer);node.timer=setTimeout(()=>node.hidden=true,8000);
  };
  const initProduct = section => {
    if(initialized.has(section))return;initialized.add(section);
    const variants=JSON.parse(section.querySelector('[data-product-variants]')?.textContent||'[]');
    const image=section.querySelector('[data-main-media] img');
    section.querySelectorAll('[data-image-src]').forEach(button=>button.addEventListener('click',()=>{
      if(!image)return;image.src=button.dataset.imageSrc;image.removeAttribute('srcset');image.alt=button.dataset.imageAlt||'';
      section.querySelectorAll('[data-image-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    }));
    section.querySelector('[data-variant-select]')?.addEventListener('change',event=>{
      const variant=variants.find(v=>String(v.id)===event.target.value);if(!variant)return;
      section.querySelector('[data-purchase-variant]').value=variant.id;
      const priceNode=section.querySelector('[data-current-price]');
      priceNode.dataset.moneyCents=variant.price_cents;
      priceNode.dataset.originalMoney=variant.price;
      priceNode.textContent=variant.price;
      refreshLocalizedPrices();
      section.querySelectorAll('[data-add-to-cart],[data-buy-now]').forEach(button=>button.disabled=!variant.available);
      section.querySelector('[data-add-label]').textContent=variant.available?messages.add_cart:messages.sold_out;
      if(variant.image&&image){image.src=variant.image;image.removeAttribute('srcset');}
      const address=new URL(location.href);address.searchParams.set('variant',variant.id);history.replaceState({},'',address);
    });
  };
  const initForm = form => {
    if(initializedForms.has(form))return;initializedForms.add(form);
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      if(form.dataset.busy||!form.reportValidity()||event.submitter?.disabled)return;
      const error=form.querySelector('[data-cart-error]');error.hidden=true;
      const buyNow=event.submitter?.hasAttribute('data-buy-now');
      const buttons=[...form.querySelectorAll('button[type=submit]')];
      const payload=new FormData(form);
      form.dataset.busy='true';buttons.forEach(button=>{button.disabled=true;button.setAttribute('aria-busy','true');});
      const select=form.querySelector('[data-variant-select]');if(select)select.disabled=true;
      try {
        const response=await fetch(`${root}cart/add.js`,{method:'POST',headers:{Accept:'application/json'},body:payload});
        const data=await response.json();
        if(!response.ok)throw new Error(typeof data.description==='string'?data.description:messages.add_error);
        if(buyNow){window.location.assign(`${root}checkout`);return;}
        await updateCount();toast();
      } catch(e) {error.textContent=e.message||messages.add_error;error.hidden=false;}
      finally {delete form.dataset.busy;buttons.forEach(button=>{button.disabled=false;button.removeAttribute('aria-busy');});if(select)select.disabled=false;}
    });
  };
  const init=()=>{
    refreshLocalizedPrices();
    document.querySelectorAll('.language-selector').forEach(form => form.classList.add('language-selector--enhanced'));
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
    document.querySelectorAll('.purchase-form,.quick-add-form').forEach(initForm);
    if(matchMedia('(prefers-reduced-motion: reduce)').matches)document.querySelectorAll('video[autoplay]').forEach(video=>{video.pause();video.removeAttribute('autoplay');});
  };
  init();document.addEventListener('shopify:section:load',init);
  window.addEventListener('pageshow',()=>{refreshLocalizedPrices();updateCount();});
})();
